import { createContext } from "react";

import { PagedResponse } from "@/types/response/PagedResponse";
import { TransactionType } from "@/types/transaction/TransactionType";

export type TransactionContextType = {
  transactions?: PagedResponse<TransactionType>;
  transactionsLoading: boolean;
  transactionsFetching: boolean;
};

export const TransactionContext = createContext<
  TransactionContextType | undefined
>(undefined);
